import { BudgetDataSource } from "@project/data/datasource/budget.datasource";
import { inject, injectable } from "inversify";

@injectable()
export class FetchAvailableColumnsByExpenseTypesUseCase {
    constructor(
        @inject(BudgetDataSource)
        private readonly budgetDataSource: BudgetDataSource,
    ) {}

    async execute(
        expenseTypes: string[],
        expenseSubtypes: string[],
    ): Promise<any> {
        return this.budgetDataSource.fetchAvailableColumnsByExpenseTypes(
            expenseTypes,
            expenseSubtypes,
        );
    }
}
